







import Vue from 'vue';
import {Component, Prop} from "vue-property-decorator";
import Company from "../../models/company/Company";
import AsiContentContainer from "../common/AsiContentContainer.vue";
import UserList from "@/components/user/UserList.vue";

@Component({
	components: {UserList, AsiContentContainer}
})
export default class CompanyTabUsers extends Vue {

	@Prop({type: Object, required: true})
	public company!: Company;

}
